/* eslint-disable no-unused-vars */
import { MinusCircle, Warehouse, Shuffle, Calendar } from 'lucide-react'
import { useState } from 'react'
import { Button, Card, Col, Container, Row, Table } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import ModalAddDriver from '../../../components/modal/Outbound/ModalAddDriver'
import ModalAddVehicle from '../../../components/modal/Outbound/ModalAddVehicle'
import api from '../../../config/AxiosInstance'
import { convertDateWithoutTime } from '../../../helpers/constants'
import { formatThousandSeparator } from '../../../utils/TextFormatter'
import toast, { Toaster } from 'react-hot-toast'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const cardStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const CreateDetailOutboundPlan = () => {
  const navigate = useNavigate()
  const { state } = useLocation()

  const [showModalAddDriver, setShowModalAddDriver] = useState(false)
  const [showModalAddVehicle, setShowModalAddVehicle] = useState(false)
  const [drivers, setDrivers] = useState([])
  const [selectedDriver, setSelectedDriver] = useState({ id: '', name: '' })
  const [vehicles, setVehicles] = useState([])
  const [selectedVehicle, setSelectedVehicle] = useState({
    id: '',
    vehicle: ''
  })
  const [changeSelectDriver, setChangeSelectDriver] = useState(null)
  const [changeSelectVehicle, setChangeSelectVehicle] = useState(null)
  const [itemCommands, setItemCommands] = useState(state?.selectedSj)
  const [submitButton, setSubmitButton] = useState(false)

  const handleSelectDriver = () => {
    if (changeSelectDriver) {
      setShowModalAddDriver(false)
      const selected = drivers.find(
        (driver) => driver.id === changeSelectDriver
      )
      setSelectedDriver({ id: selected.id, name: selected.name })
      setChangeSelectDriver(null)
    }
  }

  const handleSelectVehicle = () => {
    if (changeSelectVehicle) {
      setShowModalAddVehicle(false)
      const selected = vehicles.find(
        (vehicle) => vehicle.id === changeSelectVehicle
      )
      setSelectedVehicle({
        id: selected.id,
        vehicle: `${selected.plate_no} - ${
          selected.vehicle_type
        } - ${formatThousandSeparator(
          selected.capacity
        )} Kg - ${formatThousandSeparator(selected.volume)} cm3`
      })
      setChangeSelectVehicle(null)
    }
  }

  const handleRemoveSj = (sj, isTr) => {
    Swal.fire({
      title: `Remove ${!isTr ? 'SJ' : 'TR'} draft?`,
      text: 'This action can’t be undone',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#C12727',
      cancelButtonColor: 'transparent',
      confirmButtonText: 'Remove',
      customClass: {
        title: 'swal-title-outbound',
        popup: 'swal-popup-outbound',
        actions: 'swal-remove-outbound'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        const updateItemCommand = itemCommands.filter(
          (itemCommand) => itemCommand.sj !== sj
        )
        setItemCommands(updateItemCommand)
        if (updateItemCommand.length === 0) {
          navigate('/outbound/plan/create', {
            state: {
              selectedSj: state?.selectedSj,
              filterData: state?.filterData
            }
          })
        }
      }
    })
  }

  const handleCancelOutboundPlan = () => {
    Swal.fire({
      title: 'Cancel Creating Ticket?',
      text: 'Draft will be discarded',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#C12727',
      cancelButtonColor: 'transparent',
      confirmButtonText: 'Discard',
      cancelButtonText: 'Continue creating',
      customClass: {
        title: 'swal-title-outbound',
        popup: 'swal-popup-outbound',
        actions: 'swal-remove-outbound'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        navigate('/outbound/plan', { state: null })
      }
    })
  }

  const calculateTotalQty = (type) => {
    let qtyMap = []
    if (itemCommands?.length > 0) {
      itemCommands?.forEach((sjValue) => {
        sjValue.pickup_command.forEach((command) => {
          if (
            type === 'qty' &&
            !sjValue.is_external &&
            !sjValue.is_consignment &&
            !sjValue.is_cross_dock &&
            !sjValue.is_rr
          ) {
            const { qty, uom } = command
            if (qtyMap.length === 0) {
              qtyMap.push({ qty, uom })
            } else {
              const filterQty = qtyMap.filter(
                (dataValue) => dataValue.uom === uom
              )
              if (filterQty.length > 0) {
                const newValues = qtyMap.map((value) =>
                  value.uom === uom
                    ? { ...value, qty: (value.qty += qty) }
                    : value
                )
                qtyMap = newValues
              } else {
                qtyMap.push({ qty, uom })
              }
            }
          }
          if (
            type === 'pack' &&
            !sjValue.is_external &&
            !sjValue.is_consignment &&
            !sjValue.is_cross_dock &&
            !sjValue.is_rr
          ) {
            const { total_pack, uom_pack } = command
            if (qtyMap.length === 0) {
              qtyMap.push({ qty: total_pack, uom: uom_pack })
            } else {
              const filterQty = qtyMap.filter(
                (dataValue) => dataValue.uom === uom_pack
              )
              if (filterQty.length > 0) {
                const newValues = qtyMap.map((value) =>
                  value.uom === uom_pack
                    ? { ...value, qty: (value.qty += total_pack) }
                    : value
                )
                qtyMap = newValues
              } else {
                qtyMap.push({ qty: total_pack, uom: uom_pack })
              }
            }
          }
        })
      })
      const totalQty = qtyMap
        .map((data) => `${data.qty} ${data.uom}`)
        .join(' + ')
      return totalQty && totalQty !== '' ? totalQty : 0
    }
    return 0
  }

  const calculateTotalVolume = () => {
    if (itemCommands?.length > 0) {
      let tmpVolume = []
      itemCommands?.forEach((sjValue) => {
        if (
          !sjValue.is_external &&
          !sjValue.is_consignment &&
          !sjValue.is_cross_dock &&
          !sjValue.is_rr
        ) {
          sjValue.pickup_command.forEach((pickupCommand) => {
            let calculateTotalVolume = 0
            if (Number(pickupCommand.volume_item) !== 0) {
              calculateTotalVolume =
                Number(pickupCommand.qty) * Number(pickupCommand.volume_item)
            } else {
              calculateTotalVolume =
                (Number(pickupCommand.qty) /
                  (Number(pickupCommand.qty) /
                    Number(pickupCommand.total_pack))) *
                1000000
            }
            tmpVolume.push(calculateTotalVolume)
          })
        }
      })

      if (tmpVolume.length > 0) {
        const totalVolume = tmpVolume.reduce((acc, volume) => {
          return (acc += volume ?? 0)
        }, 0)
        return totalVolume
      }
    }
    return 0
  }

  const handleCreateOutboundPlan = async () => {
    try {
      setSubmitButton(true)

      const mappedPickups = itemCommands.map((ticket) => ({
        code: ticket.code || ticket.sj || ticket.draft_code,
        is_external: ticket.is_external || false,
        is_consignment: ticket.is_consignment || false,
        is_cross_dock: ticket.is_cross_dock || false,
        is_rr: ticket.is_rr || false,
        is_tr: ticket.is_tr || false,
        id: ticket.id || null,
        warehouse: ticket.warehouse || null,
        delivery_date: ticket.delivery_date || null,
        sales_order:
          ticket.sales_order ||
          ticket.so ||
          ticket.delivery_confirmation ||
          null,
        customer: ticket.customer || null,
        delivery_address: ticket.delivery_address || null,
        address_type: ticket.address_type || null,
        rayon: ticket.rayon || null,
        zoning: ticket.zoning || null,
        items: (ticket.pickup_command || []).map((cmd) => ({
          batch_id: cmd.batch_id || null,
          batch: cmd.batch || null,
          item_id: cmd.item_id || cmd.id || null,
          total_pack: cmd.total_pack || cmd.qty_pack || 0,
          item_name: cmd.item_name || null,
          item_alias: cmd.item_alias || null
        }))
      }))

      const payload = {
        src_warehouse_id: state?.filterData?.srcUuid || state?.filterData?.src,
        select_pick_up: mappedPickups
      }

      const res = await api.post('/outbound/outbound_plan/create', payload)
      const { status, data } = res
      if (status === 200) {
        if (Number(data.status) !== 200 && data.status) {
          throw new Error(data.message)
        }

        const skipped = data.data?.skipped_tickets || []
        if (skipped.length > 0) {
          const skippedListStr = skipped
            .map((t) => `${t.code}: ${t.reason || 'Skipped'}`)
            .join('\n')

          Swal.fire({
            title: 'Outbound Plan Created with Warnings',
            text: `Some tickets were skipped:\n${skippedListStr}`,
            icon: 'warning',
            confirmButtonColor: 'var(--primary-orange)',
            confirmButtonText: 'OK'
          }).then(() => {
            toast('Outbound created with warnings!', {
              icon: '⚠️',
              position: 'top-right',
              style: {
                fontSize: '14px',
                fontWeight: '600'
              }
            })
            navigate('/outbound/plan')
          })
        } else {
          toast.success('Outbond created!', {
            position: 'top-right',
            style: {
              fontSize: '14px',
              fontWeight: '600'
            }
          })
          navigate('/outbound/plan')
        }
      }
    } catch (err) {
      const errMsg =
        err?.response?.data?.errors?.message ||
        err?.message ||
        'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setSubmitButton(false)
    }
  }

  const propSubmitOutboundPlan = () => {
    let valueCompareItemSameLength = true
    const isTrConsignmentExist = itemCommands.some(
      (itemCommand) => itemCommand.is_tr
    )
    if (isTrConsignmentExist && !submitButton) {
      return {
        variant: 'transparent',
        className: 'btn-primary-orange',
        disabled: false,
        value: 'Submit',
        as: 'input',
        type: 'button',
        onClick: () => handleCreateOutboundPlan()
      }
    }
    if (
      itemCommands.every(
        (itemCommand) => itemCommand.is_external || itemCommand.is_consignment
      )
    ) {
      return {
        variant: 'secondary',
        disabled: true,
        value: 'Submit',
        as: 'input',
        type: 'button'
      }
    }

    if (submitButton) {
      return {
        variant: 'secondary',
        disabled: true,
        value: 'Loading...',
        as: 'input',
        type: 'button'
      }
    }
    return {
      variant: valueCompareItemSameLength ? 'transparent' : 'secondary',
      className: valueCompareItemSameLength ? 'btn-primary-orange' : '',
      disabled: valueCompareItemSameLength ? false : true,
      value: 'Submit',
      as: 'input',
      type: 'button',
      onClick: () => handleCreateOutboundPlan()
    }
  }

  return (
    <>
      <Container className="mb-3">
        <Row>
          <Col>
            <h4 style={headerTitleStyle}>Create Outbound</h4>
            <Breadcrumb onClickCancel={handleCancelOutboundPlan} />
          </Col>
        </Row>

        <Card
          style={{
            border: 'none',
            boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
            borderRadius: '16px',
            background: '#fff',
            padding: '1.5rem',
            marginBottom: '1.5rem'
          }}
        >
          <Row className="p-2 g-3 align-items-center">
            <Col xs={12} md={4} className="border-end pe-md-4">
              <div className="d-flex align-items-center gap-3">
                <div className="p-3 bg-light rounded-3 text-orange d-inline-flex">
                  <Warehouse
                    size={22}
                    style={{ color: 'var(--primary-orange)' }}
                  />
                </div>
                <div>
                  <span
                    className="text-uppercase text-muted fw-bold d-block mb-1"
                    style={{ fontSize: '11px', letterSpacing: '0.5px' }}
                  >
                    Source Warehouse
                  </span>
                  <span className="fw-bold text-dark fs-6">
                    {state?.filterData.srcLabel || state?.filterData.src || '-'}
                  </span>
                </div>
              </div>
            </Col>

            <Col xs={12} md={4} className="border-end px-md-4">
              <div className="d-flex align-items-center gap-3">
                <div className="p-3 bg-light rounded-3 text-orange d-inline-flex">
                  <Shuffle
                    size={22}
                    style={{ color: 'var(--primary-orange)' }}
                  />
                </div>
                <div>
                  <span
                    className="text-uppercase text-muted fw-bold d-block mb-1"
                    style={{ fontSize: '11px', letterSpacing: '0.5px' }}
                  >
                    External & Consignment
                  </span>
                  <span
                    className="fw-semibold text-muted"
                    style={{ fontSize: '13px' }}
                  >
                    {(state?.filterData.other_src || [])
                      .map((item) => item.label)
                      .join(', ') || '-'}
                  </span>
                </div>
              </div>
            </Col>

            <Col xs={12} md={4} className="ps-md-4">
              <div className="d-flex align-items-center gap-3">
                <div className="p-3 bg-light rounded-3 text-orange d-inline-flex">
                  <Calendar
                    size={22}
                    style={{ color: 'var(--primary-orange)' }}
                  />
                </div>
                <div>
                  <span
                    className="text-uppercase text-muted fw-bold d-block mb-1"
                    style={{ fontSize: '11px', letterSpacing: '0.5px' }}
                  >
                    Delivery Date Range
                  </span>
                  <span className="fw-bold text-dark fs-6">
                    {state?.filterData.delivery_date_start &&
                    state?.filterData.delivery_date_end
                      ? `${convertDateWithoutTime(state?.filterData.delivery_date_start)} - ${convertDateWithoutTime(state?.filterData.delivery_date_end)}`
                      : state?.filterData.delivery_date
                        ? convertDateWithoutTime(
                            state?.filterData.delivery_date
                          )
                        : '-'}
                  </span>
                </div>
              </div>
            </Col>
          </Row>
        </Card>
      </Container>
      <Container>
        <Card style={cardStyle}>
          <Row>
            <Col xs={12} md={3} lg={3}>
              <Table borderless className="mt-3">
                <tbody>
                  <tr>
                    <td className="fw-bold" width={'10%'}>
                      Qty
                    </td>
                    <td className="fw-bold" width={'5%'}>
                      :
                    </td>
                    <td>
                      <span style={{ color: '#F7931E' }} className="fw-bold">
                        {calculateTotalQty('qty')}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="fw-bold" width={'10%'}>
                      Pack
                    </td>
                    <td className="fw-bold" width={'5%'}>
                      :
                    </td>
                    <td>
                      <span style={{ color: '#F7931E' }} className="fw-bold">
                        {calculateTotalQty('pack')}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="fw-bold" width={'10%'}>
                      Vol
                    </td>
                    <td className="fw-bold" width={'5%'}>
                      :
                    </td>
                    <td>
                      <span style={{ color: '#F7931E' }} className="fw-bold">
                        {formatThousandSeparator(calculateTotalVolume())} cm3
                      </span>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
        </Card>
      </Container>
      <Container>
        {itemCommands.map((itemCommand, index) => (
          <ListDataSj
            key={itemCommand.id ?? index}
            data={itemCommand}
            number={index + 1}
            onHandleRemoveSj={handleRemoveSj}
          />
        ))}
      </Container>

      <Container>
        <div className="col-12 mb-5">
          <div className="row">
            <div className="col-3" style={{ marginLeft: '-1rem' }}>
              <button
                className="btn fw-bold"
                style={{ color: '#C12727' }}
                onClick={handleCancelOutboundPlan}
              >
                Cancel
              </button>
            </div>
            <div className="col-9" style={{ marginLeft: '1rem' }}>
              <div className="d-flex w-100 justify-content-end">
                <Button {...propSubmitOutboundPlan()} />
              </div>
            </div>
          </div>
        </div>
      </Container>

      <ModalAddDriver
        show={showModalAddDriver}
        drivers={drivers}
        onHide={() => {
          setShowModalAddDriver(false)
          setChangeSelectDriver(null)
        }}
        onHandleSelectDriver={handleSelectDriver}
        onHandleChangeSelectDriver={setChangeSelectDriver}
        dataChangeSelectDriver={changeSelectDriver}
      />
      <ModalAddVehicle
        show={showModalAddVehicle}
        vehicles={vehicles}
        onHide={() => {
          setShowModalAddVehicle(false)
          setChangeSelectVehicle(null)
        }}
        onHandleSelectVehicle={handleSelectVehicle}
        onHandleChangeSelectVehicle={setChangeSelectVehicle}
        dataChangeSelectVehicle={changeSelectVehicle}
        totalVolume={calculateTotalVolume()}
      />
      <Toaster />
    </>
  )
}

const Breadcrumb = ({ onClickCancel }) => (
  <nav aria-label="breadcrumb">
    <ol className="breadcrumb" style={{ fontSize: '12px', cursor: 'pointer' }}>
      <li className="breadcrumb-item sj-item" onClick={onClickCancel}>
        <span className="text-black fw-bold">OUTBOUND</span>
      </li>
      <li
        className="breadcrumb-item sj-item active text-uppercase"
        aria-current="page"
      >
        Create
      </li>
    </ol>
  </nav>
)

const ListDataSj = ({ data, number, onHandleRemoveSj }) => (
  <Card style={cardStyle} className="mb-4">
    <div className="col-12">
      <Row>
        <Col xs={10} md={8} lg={8}>
          <p className="d-flex">
            <span className="fw-bold mr-2">
              {number}. {data.draft}
            </span>
          </p>
        </Col>
        <Col xs={2} md={4} lg={4}>
          <div className="d-flex w-100 justify-content-end">
            <button
              className="btn btn-danger btn-sm d-flex flex-row gap-2"
              onClick={() => onHandleRemoveSj(data.sj, data.is_tr)}
            >
              <span>REMOVE</span>
              <MinusCircle
                size={16}
                style={{ color: 'white' }}
                className="ml-2"
              />
            </button>
          </div>
        </Col>
      </Row>
    </div>
    <Col xs={12} md={12} lg={12}>
      <Col xs={12} md={4} lg={4}>
        <p>{data.customer}</p>
      </Col>
    </Col>
    <Col xs={12} md={12} lg={12}>
      <Col xs={12} md={6} lg={6}>
        <div dangerouslySetInnerHTML={{ __html: data.delivery_address }}></div>
      </Col>
    </Col>
    <Col xs={12} md={12} lg={12} className="mt-2">
      <Col xs={12} md={12} lg={12}>
        <div
          style={{
            color: 'var(--primary-orange)',
            fontSize: '13px',
            fontWeight: '500'
          }}
        >
          Rayon {data.rayon || '-'} &bull; Zoning {data.zoning || '-'} &bull;
          Delivery Date{' '}
          {data.delivery_date
            ? convertDateWithoutTime(data.delivery_date)
            : '-'}
        </div>
      </Col>
    </Col>
    <Col xs={12} md={12} lg={12} className="mt-3">
      <h6 className="fw-bold text-muted">PICK UP COMMAND</h6>
    </Col>
    <Col xs={12} md={12} lg={12} className="mt-3 pe-2">
      <Table borderless responsive size="sm" style={{ fontSize: '14px' }}>
        <thead
          className="table-secondary"
          style={{ borderColor: 'transparent' }}
        >
          <tr>
            <th className="p-2 align-middle" style={tableHeaderStyle}>
              No
            </th>
            <th className="p-2 align-middle" style={tableHeaderStyle}>
              Item Code - Name
            </th>
            <th className="p-2 align-middle" style={tableHeaderStyle}>
              Item Alias
            </th>
            <th className="p-2 align-middle" style={tableHeaderStyle}>
              Batch
            </th>
            <th className="p-2 align-middle" style={tableHeaderStyle}>
              Expired
            </th>
            <th
              className="p-2 align-middle text-center"
              style={tableHeaderStyle}
            >
              Base Qty UOM
            </th>
            <th className="p-2 align-middle text-end" style={tableHeaderStyle}>
              Qty Kemasan
            </th>
          </tr>
        </thead>
        <tbody>
          {data.pickup_command.length === 0 && (
            <tr>
              <td colSpan={8}>
                <p className="fw-bold text-center">Item Empty</p>
              </td>
            </tr>
          )}
          {data.pickup_command.length > 0 &&
            data.pickup_command.map((item, index) => (
              <ListPickupCommand
                key={item.id ?? index}
                data={item}
                number={index + 1}
              />
            ))}
        </tbody>
      </Table>
    </Col>
  </Card>
)

const ListPickupCommand = ({ data, number }) => (
  <tr>
    <td
      className="p-2 align-middle"
      style={{ backgroundColor: data?.item_alias ? '#FF8F8F' : '' }}
    >
      {number}
    </td>
    <td
      className="p-2 align-middle"
      style={{ backgroundColor: data?.item_alias ? '#FF8F8F' : '' }}
    >
      {data.item_code} - {data.item_name}
    </td>
    <td
      className="p-2 align-middle"
      style={{ backgroundColor: data?.item_alias ? '#FF8F8F' : '' }}
    >
      {data.item_alias ?? '-'}
    </td>
    <td
      className="p-2 align-middle"
      style={{ backgroundColor: data?.item_alias ? '#FF8F8F' : '' }}
    >
      {data.batch}
    </td>
    <td
      className="p-2 align-middle"
      style={{ backgroundColor: data?.item_alias ? '#FF8F8F' : '' }}
    >
      {data.exp_date
        ? convertDateWithoutTime(data.exp_date)
        : convertDateWithoutTime(data.expired)}
    </td>
    <td
      className="p-2 align-middle text-center"
      style={{ backgroundColor: data?.item_alias ? '#FF8F8F' : '' }}
    >
      {data.qty} {data.uom}
    </td>
    <td
      className="p-2 align-middle text-end"
      style={{ backgroundColor: data?.item_alias ? '#FF8F8F' : '' }}
    >
      {data.total_pack} {data.uom_pack}
    </td>
  </tr>
)

export default CreateDetailOutboundPlan
